// DI   TGP-029
// Email popup with localStorage persistence and clipboard copy

(function() {
  'use strict';

  const STORAGE_KEY = 'emailPopupDismissed';
  let popup = null;
  let config = {};

  function init() {
    popup = document.querySelector('[data-email-popup]');
    if (!popup) return;

    let newsLetterSection = document.querySelector('[data-section-type="newsletter-subscribe"]') || document.querySelector('.newsletter-subscribe');

    // Don't show popup on /challenge URL
    if (window.location.pathname === '/challenge' || newsLetterSection) {
      return;
    }

    // Check if customer_posted param is present
    const urlParams = new URLSearchParams(window.location.search);
    const isCustomerPosted = urlParams.has('customer_posted');

    // Get config from data attributes
    config = {
      delay: parseFloat(popup.dataset.delay) * 1000 || 3500,
      useKlaviyo: popup.dataset.useKlaviyo === 'true',
      klaviyoListId: popup.dataset.klaviyoListId,
      klaviyoApiKey: popup.dataset.klaviyoApiKey,
      discountCode: popup.dataset.discountCode
    };

    // Check if popup was already shown/dismissed (skip check if customer_posted param is present)
    if (!isCustomerPosted && localStorage.getItem(STORAGE_KEY)) {
      return;
    }

    // Show popup after delay (skip delay if customer_posted param is present)
    const delay = isCustomerPosted ? 0 : config.delay;
    setTimeout(showPopup, delay);

    // Setup event listeners
    setupEventListeners();
  }

  function showPopup() {
    popup.classList.add('is-visible');
    // Trigger animation after display
    requestAnimationFrame(() => {
      popup.classList.add('is-active');
    });
    lockBodyScroll();
  }

  function hidePopup() {
    popup.classList.remove('is-active');
    setTimeout(() => {
      popup.classList.remove('is-visible');
      unlockBodyScroll();
    }, 300);
  }

  function lockBodyScroll() {
    document.body.classList.add('email-popup-open');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('email-popup-open');
  }

  function setupEventListeners() {
    // Close buttons
    const closeButtons = popup.querySelectorAll('[data-email-popup-close]');
    closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        dismissPopup();
      });
    });

    // Copy button
    const copyBtn = popup.querySelector('[data-email-popup-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', copyToClipboard);
    }

    // Auto-copy on success state
    const successState = popup.querySelector('[data-email-popup-success-state]');
    if (successState) {
      // Mark as submitted and auto-copy
      localStorage.setItem(STORAGE_KEY, 'true');
      setTimeout(() => {
        copyToClipboard(null, true);
      }, 500);
    }

    // Prevent modal content clicks from closing
    const modal = popup.querySelector('.email-popup__modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  function dismissPopup() {
    localStorage.setItem(STORAGE_KEY, 'true');
    hidePopup();
  }

  function copyToClipboard(e, isAuto = false) {
    if (e) e.preventDefault();

    const codeElement = popup.querySelector('[data-email-popup-code]');
    const copyBtn = popup.querySelector('[data-email-popup-copy]');
    const copyText = copyBtn.querySelector('[data-copy-text]');
    const copiedText = copyBtn.querySelector('[data-copied-text]');
    
    if (!codeElement) return;

    const code = codeElement.textContent.trim();

    // Copy to clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        showCopiedFeedback(copyText, copiedText);
      }).catch(err => {
        console.error('Failed to copy:', err);
        fallbackCopy(code, copyText, copiedText);
      });
    } else {
      fallbackCopy(code, copyText, copiedText);
    }
  }

  function fallbackCopy(text, copyText, copiedText) {
    // Fallback for older browsers
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    
    try {
      document.execCommand('copy');
      showCopiedFeedback(copyText, copiedText);
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }
    
    document.body.removeChild(textarea);
  }

  function showCopiedFeedback(copyText, copiedText) {
    if (copyText) copyText.style.display = 'none';
    if (copiedText) copiedText.style.display = 'inline';
    
    setTimeout(() => {
      if (copyText) copyText.style.display = 'inline';
      if (copiedText) copiedText.style.display = 'none';
    }, 2000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
